import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DataSourceIDEnum, DataSourceType, DataSourceTypeCodeConfig, EDataSourceCategory } from '../../../../models/dataSource';
import CodeRequiredIcon from "../../../../assets/icons/code_required.svg?react";
import NoCodeRequiredIcon from "../../../../assets/icons/no_code_required.svg?react";
import BestUsedForIcon from "../../../../assets/icons/best_used_for.svg?react";
import RequirementsIcon from "../../../../assets/icons/requirements.svg?react";

interface IDataSourceTypePanelContentProps {
  dataSourceType?: DataSourceType;
}

const DataSourceTypePanelContentV2: FunctionComponent<IDataSourceTypePanelContentProps> = ({ dataSourceType }) => {
  const { t } = useTranslation('data_sources');

  const id = dataSourceType.id as DataSourceIDEnum;
  const configuration = dataSourceType?.configuration as DataSourceTypeCodeConfig | undefined;
  const usedFor = t(`catalog.${id}.usedFor`, { returnObjects: true });
  const usedForItems = Array.isArray(usedFor) ? usedFor : [];
  const requirements = t(`catalog.${id}.requirements`, { returnObjects: true });
  const requirementItems = Array.isArray(requirements) ? requirements : [];

  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-2'>
        <>
          {configuration?.website && (
            <div className='mr-5 inline-block'>
              <a href={configuration.website} className='inline-block text-sm text-brand-600 underline'>
                {t('slideover.content.visit_website')}
              </a>
            </div>
          )}
          {dataSourceType?.category === EDataSourceCategory.CODE ? (
            <div className='inline-block'>
              <CodeRequiredIcon className='mr-3 inline-block size-6' />
              <p className='inline-block text-base font-semibold text-brand-600'>
                {t(
                  id === DataSourceIDEnum.WordPress
                    ? 'slideover.content.plugin'
                    : id === DataSourceIDEnum.Shopify
                      ? 'slideover.content.app'
                      : 'slideover.content.code_required'
                )}
              </p>
            </div>
          ) : (
            <div className='inline-block'>
              <NoCodeRequiredIcon className='mr-3 inline-block size-6' />
              <p className='inline-block text-base font-semibold text-brand-600'>{t('slideover.content.no_code_required')}</p>
            </div>
          )}
        </>
        <p className='text-pretty text-sm text-gray-950'>{t(`catalog.${id}.description`)}</p>
      </div>
      
      
      <div className='flex flex-col gap-2'>
        <div className='inline-block'>
          <BestUsedForIcon className='mr-3 inline-block size-6' />
          <p className='inline-block text-base font-semibold text-brand-600'>{t('slideover.content.best_used_for')}</p>
        </div>
        <div>
          <ul className='list-outside list-disc pl-[26px]'>
            {usedForItems.map((use) => (
              <li key={use} className='text-pretty text-sm text-gray-950'>
                {use}
              </li>
            ))}
          </ul>
        </div>
      </div>
      
      <div className='flex flex-col gap-2'>
        <div className='inline-block'>
          <RequirementsIcon className='inline-block h-6 w-6 mr-3' />
          <p className='inline-block text-brand-600 text-base font-semibold'>{t('slideover.content.user_need')}</p>
        </div>
        <div>
          <ul className='list-disc list-outside pl-[26px]'>
            {requirementItems.map((requirement) => (
              <li key={requirement} className='text-gray-950 text-sm text-pretty'>
                {requirement}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DataSourceTypePanelContentV2;
